// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SurveyQuestionCategoryModel {
    'questionCategoryId'?: number;
    'questionCategoryTypeCode'?: string;
    'questionCategoryTypeDescription'?: string;
    'description'?: string;
    'questionCategoryCode'?: string;
    'questionCategoryTypeId'?: number;
    'userName'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SurveyQuestionCategoryModel>> = [
        {
            "name":     "questionCategoryId",
            "baseName": "questionCategoryId",
            "type":     "number"
        },
        {
            "name":     "questionCategoryTypeCode",
            "baseName": "questionCategoryTypeCode",
            "type":     "string"
        },
        {
            "name":     "questionCategoryTypeDescription",
            "baseName": "questionCategoryTypeDescription",
            "type":     "string"
        },
        {
            "name":     "description",
            "baseName": "description",
            "type":     "string"
        },
        {
            "name":     "questionCategoryCode",
            "baseName": "questionCategoryCode",
            "type":     "string"
        },
        {
            "name":     "questionCategoryTypeId",
            "baseName": "questionCategoryTypeId",
            "type":     "number"
        },
        {
            "name":     "userName",
            "baseName": "userName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return SurveyQuestionCategoryModel.attributeTypeMap;
    }
}
